import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// project imports
import useAuth from 'hooks/useAuth';
import Loading from 'ui-component/Loading';

import Error from 'views/pages/maintenance/Error';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const RoleGuard = ({ children, userPermission, permissionID }) => {
    const { user } = useAuth();
    if (userPermission.includes(user?.user_type)) {
        return children;
    }
    if (user?.Role?.accessIDs.split(',').includes(permissionID)) {
        return children;
    }

    // return <Error />;
    return user ? <Error /> : <Loading />;
};

RoleGuard.propTypes = {
    children: PropTypes.node
};

export default RoleGuard;
